// extracted by mini-css-extract-plugin
export default {"containerClassName":"UploadWrapper_containerClassName__TxIHX","overlayContent":"UploadWrapper_overlayContent__tMVcg"};